'use strict';

module.exports = require('./Checkbox');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-checkbox/lib/index.js
 ** module id = 150
 ** module chunks = 0
 **/